import { PhotoIcon } from '@heroicons/react/24/outline'
import React from 'react'
import { t } from 'shared'

const AddButton = ({ onClick, loading }: { onClick?: React.MouseEventHandler; loading?: boolean }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={loading}
    className="flex flex-col items-center justify-center gap-1.5 w-[130px] aspect-3/2 border border-gray-300 rounded-xl bg-white cursor-pointer shrink-0 hover:bg-gray-50"
  >
    <span className="relative inline-block text-me-purple-700">
      <PhotoIcon className="w-8 h-8" />
      <span className="absolute -bottom-0.5 -right-[5px] text-base font-bold leading-none text-me-purple-700">+</span>
    </span>
    <span className="text-[0.8rem] font-bold text-me-purple-700 text-center leading-[1.3] whitespace-pre-line">
      {t('image_upload.add_images')}
    </span>
  </button>
)

export default AddButton
